import {createApp} from 'vue'
import Store from 'store'
import SearchHeader from './SearchHeader'

const component = createApp(SearchHeader).use(Store)

const el = '.nlx-component--search-header'
const DOM = document.querySelector(el)

if(DOM){
    component.mount(el)
}

